import React from 'react';
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useGlobalData } from '../../context/globalDataContxt';
import './PosgradoCareerFeed.scss';

const PosgradoCareerFeed = ({ title, careerPlacesFilter, careerModalityFilter, careerMicrosite }) => {

  const { careersAll } = useGlobalData();
  
  // const careers = useAllCareersByMicrosite(careerMicrosite?.id, careerPlacesFilter?.id, careerModalityFilter)
  const careersList = filterCareers(careersAll, careerMicrosite, careerPlacesFilter, careerModalityFilter)

  return (
    <div className="career-feed my-3 my-md-5">
      <div className="career-feed-title my-2">
        {title}
      </div>
      <div className="career-cards-container">     
        {careersList && careersList.map((career, index) => (
          career?.career_category?.name !== "Especialidad Cs Salud" &&
            <Link to={`/carreras/${career.slug}`} key={index} className="career-card">
              <div className="career-info">
                <div className='career-title'>{career.name}</div>
                <div className='career-information'>
                  {career.startCareerDate ? `${career.startCareerDate} | ` : ''}
                  {career.modality === "Ambas" 
                    ? "Presencial / A Distancia" 
                    : career.modality === "Distancia" 
                      ? "A Distancia" 
                      : career.modality === "Hibrido" 
                        ? "Híbrido"
                        : career.modality
                  }
                  {career.career_places && career.career_places.length > 0 ? (
                    <>
                      {" | "}
                      {career.career_places.map((place, index) => (
                        <React.Fragment key={index}>
                          <FontAwesomeIcon icon={["fas", "fa-location-dot"]} size="xs" className="me-1" />
                          {place.title}
                          {index < career.career_places.length - 1 && " "}
                        </React.Fragment>
                      ))}
                    </>
                  ) : ''}
                </div>
              </div>
              <div className="career-image">
                <img src={career.coverImg?.url ?  career.coverImg?.url : 'https://ucc-uploads-qa.s3.sa-east-1.amazonaws.com/Slides_Generico_horizontal_89b349f7c7_b88c51e1de.jpg' } 
                alt={career.name} />
              </div>
            </Link>
        ))}

        {careerMicrosite.slug === "salud-ambiente" &&
          <Link to={`/propuesta-academica/especialidades-medicas`} key={"especialidades-médicas"} className="career-card">
            <div className="career-info">
              <div className='career-title'>Especialidades Médicas</div>
              <div className='career-information'>
              </div>
            </div>
            <div className="career-image">
              <img src={'https://ucc-uploads.s3.sa-east-1.amazonaws.com/small_ucc_salud_web_56fa470ce0_bbeb71a788.jpg' } 
              alt={"Especialidades Médicas"} />
            </div>
          </Link>
        }
      </div>
    </div>
  );
};

function filterCareers(careersAll, careerMicrosite, careerPlacesFilter = null, careerModalityFilter = null) {
  // Validamos que se pase el microsite obligatorio
  if (!careerMicrosite?.id) {
    throw new Error("El parámetro 'careerMicrosite.id' es obligatorio.");
  }

  return careersAll.filter((career) => {
    // Filtramos por microsite obligatorio
    const matchesMicrosite = career.p_ucc_microsite?.id === careerMicrosite.id;

    // Filtramos por lugar (si está definido)
    const matchesPlaces = careerPlacesFilter?.id
      ? career.career_places?.some(place => place.id === careerPlacesFilter.id)
      : true;
    
    // Filtramos por modalidad (si está definida)
    const matchesModality = careerModalityFilter
      ? [
          ...(careerModalityFilter === "Presencial" || careerModalityFilter === "Distancia"
            ? [careerModalityFilter, "Ambas"]
            : [careerModalityFilter]),
        ].includes(career.modality)
      : true;

    return matchesMicrosite && matchesPlaces && matchesModality;
  });
}

export default PosgradoCareerFeed;